import { defineStore } from "pinia";
import { useForm } from "@/shared/composables/form/useForm";
import { StudyFilterModel } from "@/app/study/models/StudyFilterModel";
import { ref } from "vue";
import { PreferencesModel } from "@/app/users/modules/preferences/models/PreferencesModel";

export const useStudyFilter = defineStore(
  "studyFilter",
  () => {
    const isInitialPreferenceFilterDone = ref(true);

    const {
      modelClass: studyFilterModel,
      setModelData,
      validateModel,
      isValid,
      errors,
      clearModel,
    } = useForm(StudyFilterModel);

    function clearStudyFilter() {
      clearModel();
      isInitialPreferenceFilterDone.value = true;
    }

    function applyPreferencesOnFilter(
      preferences: PreferencesModel,
      acronyms: string[],
      userId: number | string,
    ) {
      if (!preferences) return;

      if (preferences.searchPreferences) {
        studyFilterModel.value.setTime(preferences.searchPreferences.defaultFilter);
        studyFilterModel.value.setSize(preferences.searchPreferences.examsPerPage ?? 30);
        studyFilterModel.value.setDefaultMode(preferences.searchPreferences.defaultMode ?? "");
        studyFilterModel.value.setDefaultSortOrder(
          preferences.searchPreferences.defaultSortOrder ?? "",
        );
        studyFilterModel.value.setReferenceDate(preferences.searchPreferences.referenceDate ?? "");
        studyFilterModel.value.setOnlyExamsRequestedByMe(
          preferences.searchPreferences.onlyExamsRequestedByMe ?? false,
        );

        if (preferences.searchPreferences.onlyExamsRequestedByMe) {
          studyFilterModel.value.setRequestDoctorId(String(userId));
        } else {
          studyFilterModel.value.setRequestDoctorId(null);
        }
      }

      if (preferences.reportPreferences) {
        studyFilterModel.value.setReportStatuses(
          preferences.reportPreferences.defaultReportStatus ?? [],
        );
      }

      if (acronyms && acronyms.length) {
        studyFilterModel.value.setModalities(acronyms);
      }
    }

    return {
      studyFilterModel,
      setModelData,
      validateModel,
      isValid,
      errors,
      clearModel,
      clearStudyFilter,
      applyPreferencesOnFilter,
      isInitialPreferenceFilterDone,
    };
  },
  {
    persist: {
      storage: sessionStorage,
    },
  },
);
